import { Tooltip } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { is_file_uploaded } from "../../../utils/classRoomUtils";

export const PreviewItem = ({ previewUrl, onRemove, onCrop }) => {
  const isFileUploaded = is_file_uploaded(previewUrl);

  const handleClick = () => {
    if (isFileUploaded) return;
    onCrop();
  };

  return (
    <div className="image-preview">
      <Tooltip title="Remove Image">
        <span className="cross-image-preview" onClick={onRemove}>
          <ClearIcon fontSize="small" />
        </span>
      </Tooltip>
      <img
        src={previewUrl}
        alt=""
        onClick={handleClick}
        className={`${isFileUploaded ? "" : "unuploaded-file"}`}
        loading="lazy"
        decoding="async"
      />
    </div>
  );
};
